/**
 * Legal pages (Terms of Service, Privacy Policy) are served from the
 * marketing site (`apps/website`), NOT from this app — they are two different
 * Firebase Hosting sites (see `firebase.json` hosting targets "web" vs
 * "website"). An app-relative `/legal/terms` or `/privacy` link 404s here, so
 * these must be absolute URLs. Env-driven so prod can point elsewhere (prod:
 * www.praesto.it), mirroring the website's own app-origin fallback
 * (`apps/website/src/components/Header.astro`'s `PUBLIC_APP_URL`).
 */
const WEBSITE_URL =
  (import.meta.env["VITE_WEBSITE_URL"] as string | undefined) ?? "https://www.praesto.mademind.it";

/** IT is served unprefixed on the website, EN under `/en` (see `apps/website/astro.config.mjs`). */
export function legalUrl(locale: "it" | "en", slug: string): string {
  return `${WEBSITE_URL}${locale === "en" ? "/en" : ""}${slug}`;
}
